export default __webpack_public_path__ + "static/other-business-44b28a0839bce79ac3875af097434d31.jpg";